<template>
  <div class="register-container">
    <el-card class="register-card" shadow="hover">
      <el-row :span="24">
        <el-col :span="24">
          <h2 class="register-title">{{ $t('register') }}</h2>
        </el-col>
        <!-- {{ categoriesGetter }} -->
        <el-form :model="form" :rules="rules" ref="registerForm" label-width="120px">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Овог</span>
                <el-input v-model="form.ovog" placeholder="Та овгоо оруулна уу" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Нэр</span>
                <el-input v-model="form.lastname" :placeholder="$t('enteryourlastname')" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Ажилладаг байгууллага</span><br>
                <el-select v-model="form.organizationName" placeholder="Та сонгоно уу">
                  <el-option
                    v-for="item in organization"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Цол</span>
                <el-input v-model="form.tsol" placeholder="Та цолоо оруулна уу" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Хүйс</span><br>
                <el-select v-model="form.gender" placeholder="Та сонгоно уу">
                  <el-option
                    v-for="item in genderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Нас</span>
                <el-input v-model="form.age" placeholder="Та насаа оруулна уу" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="lastname">
                <span>Орлцох төрөл</span><br>
                <el-select v-model="form.weight" placeholder="Та сонгоно уу">
                  <el-option
                    v-for="item in weight"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="phone">
                <span>{{ $t('phone') }}</span>
                <el-input v-model="form.phone" type="number" placeholder="Та утасны дугаараа оруулна уу" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="password">
                <span>{{ $t('password') }}</span>
                <el-input v-model="form.password" type="password" placeholder="Та нууц үгээ оруулна уу" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item class="formItemLeft" prop="confirmPassword">
                <span>{{ $t('repassword') }}</span>
                <el-input v-model="form.confirmPassword" type="password" placeholder="Та нууц үгээ ахин оруулна уу" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button class="signup_button w-100 signup_button" type="primary" @click="createUser(form)">Бүртгүүлэх</el-button><br/><br/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button class="signup_button w-100 loginButton" type="primary" :style="'background-color:' + bgColor()" @click="goToLogin()">{{ $t('login') }}</el-button><br/>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button  class="register_button w-100" type="text" @click="resetForm">Цэвэрлэх</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-card>
  </div>
  </template>

<script>
import services from '@/helpers/services.js'
import {
  mapGetters
} from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'categoriesGetter'
    ])
  },
  data () {
    return {
      form: {
        lastname: '',
        phone: '',
        password: '',
        confirmPassword: '',
        ovog: '',
        organizationName: '',
        tsol: '',
        age: 0,
        weight: ''
      },
      rules: {
        password: [{ required: true, message: 'Please enter password', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: 'Please confirm password', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('Passwords do not match'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      genderOptions: [{
        value: 'Эрэгтэй',
        label: 'Эрэгтэй'
      }, {
        value: 'Эмэгтэй',
        label: 'Эмэгтэй'
      }, {
        value: 'Бусад',
        label: 'Бусад'
      }],
      organization: [{
        value: 'Батлах хамгаалах яам',
        label: 'Батлах хамгаалах яам'
      }, {
        value: 'Зэвсэгт хүчний жанжин штаб',
        label: 'Зэвсэгт хүчний жанжин штаб'
      }, {
        value: 'Хил хамгаалах ерөнхий газар',
        label: 'Хил хамгаалах ерөнхий газар'
      }, {
        value: 'Онцгой байдлын ерөнхий газар',
        label: 'Онцгой байдлын ерөнхий газар'
      }, {
        value: 'Цагдаагийн ерөнхий газар',
        label: 'Цагдаагийн ерөнхий газар'
      }, {
        value: 'Тагнуулын ерөнхий газар',
        label: 'Тагнуулын ерөнхий газар'
      }, {
        value: 'Төрийн тусгай хамгаалалтын газар',
        label: 'Төрийн тусгай хамгаалалтын газар'
      }, {
        value: 'Дотоодын цэрэг',
        label: 'Дотоодын цэрэг'
      }, {
        value: 'Шүүх шинжилгээний ерөнхий газар',
        label: 'Шүүх шинжилгээний ерөнхий газар'
      }, {
        value: 'Шүүхийн шийдвэр гүйцэтгэх ерөнхий газар',
        label: 'Шүүхийн шийдвэр гүйцэтгэх ерөнхий газар'
      }],
      weight: [{
        value: '63кг - Эрэгтэй',
        label: '63кг - Эрэгтэй'
      }, {
        value: '68кг - Эмэгтэй',
        label: '68кг - Эмэгтэй'
      }, {
        value: '68кг - Эрэгтэй',
        label: '68кг - Эрэгтэй'
      }, {
        value: '73кг - Эмэгтэй',
        label: '73кг - Эмэгтэй'
      }, {
        value: '73кг - Эрэгтэй',
        label: '73кг - Эрэгтэй'
      }, {
        value: '78кг - Эмэгтэй',
        label: '78кг - Эмэгтэй'
      }, {
        value: '78кг - Эрэгтэй',
        label: '78кг - Эрэгтэй'
      }, {
        value: '85кг - Эрэгтэй',
        label: '85кг - Эрэгтэй'
      }, {
        value: '93кг - Эрэгтэй',
        label: '93кг - Эрэгтэй'
      }, {
        value: '+93кг - Эрэгтэй',
        label: '+93кг - Эрэгтэй'
      }, {
        value: '+78кг - Эмэгтэй',
        label: '+78кг - Эмэгтэй'
      }, {
        value: '+40 Мастер ангилал',
        label: '+40 Мастер ангилал'
      }, {
        value: '-80кг - Эрэгтэй',
        label: '-80кг - Эрэгтэй'
      }, {
        value: '+80кг - Эрэгтэй',
        label: '+80кг - Эрэгтэй'
      }, {
        value: '-70кг - Эмэгтэй',
        label: '-70кг - Эмэгтэй'
      }, {
        value: '+70кг - Эмэгтэй',
        label: '+70кг - Эмэгтэй'
      }]
    }
  },
  methods: {
    resetForm () {
      this.$refs.registerForm.resetFields()
    },
    goToLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    goToRegister () {
      this.$router.push({
        path: '/register'
      })
    },
    createUser (form) {
      this.$root.fullscreenLoading = true
      const payload = {
        name: form.lastname,
        phone: form.phone,
        password: this.form.password,
        ovog: form.ovog,
        organization_name: form.organizationName,
        tsol: form.tsol,
        age: form.age,
        weight: form.weight,
        gender: form.gender,
        company_id: this.categoriesGetter[0].company_id
      }
      services.registerService(payload)
      // this.$root.fullscreenLoading = true
        .then((response) => {
          // alert('success')
          if (response.status === 'success') {
            // alert('success')
            this.$root.fullscreenLoading = false
            this.$alert('Таны бүртгэл амжилттай хийгдлээ.', 'Амжилттай', {
              confirmButtonText: 'Ойлголоо',
              callback: action => {
                this.$router.push({
                  path: '/login'
                })
              }
            })
          }
        })
    },
    bgColor () {
      if (window.location.hostname === 'www.iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}
</script>

  <style scoped>
  .register-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: #f5f5f5;
  }

  .register-card {
    /* height: 100%; */
    width: 80%;
    padding: 30px;
    border-radius: 40px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .register-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .loginButton{
    background-color: #5E1EE5;
  }

  .formItemLeft{
    margin-left: -120px
  }

  .el-select{
    width: 100%
  }
  </style>
